// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cultivationTypeEnum } from './CultivationTypeEnum';
import { mediumRecipeId } from './MediumRecipe';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationProcedureId = (z.number());
export const fermentationProcedure = z.object({
    id: fermentationProcedureId,
    name: z.string(),
    version: z.string(),
    description: z.string().nullable(),
    changelog: z.string().nullable(),
    fermentor_model_id: z.number().nullable(),
    cultivation_type: cultivationTypeEnum.nullable(),
    default_medium_recipe_id: mediumRecipeId.nullable(),
    parent_procedure_id: fermentationProcedureId.nullable(),
    is_locked: z.boolean(),
    required_pre_cleaning_procedure_id: z.number().nullable(),
    required_post_cleaning_procedure_id: z.number().nullable(),
    owner_operator_id: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    unit_preferences: z.unknown().nullable(),
    archived_at: z.date().nullable(),
    archived_by: operatorId.nullable(),
    dashboard_id: z.number().nullable(),
    pre_inoculation_pins: z.unknown(),
});
export const fermentationProcedureInitializer = z.object({
    id: fermentationProcedureId.optional(),
    name: z.string(),
    version: z.string(),
    description: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    fermentor_model_id: z.number().optional().nullable(),
    cultivation_type: cultivationTypeEnum.optional().nullable(),
    default_medium_recipe_id: mediumRecipeId.optional().nullable(),
    parent_procedure_id: fermentationProcedureId.optional().nullable(),
    is_locked: z.boolean().optional(),
    required_pre_cleaning_procedure_id: z.number().optional().nullable(),
    required_post_cleaning_procedure_id: z.number().optional().nullable(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    unit_preferences: z.unknown().optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    dashboard_id: z.number().optional().nullable(),
    pre_inoculation_pins: z.unknown().optional(),
});
export const fermentationProcedureMutator = z.object({
    id: fermentationProcedureId.optional(),
    name: z.string().optional(),
    version: z.string().optional(),
    description: z.string().optional().nullable(),
    changelog: z.string().optional().nullable(),
    fermentor_model_id: z.number().optional().nullable(),
    cultivation_type: cultivationTypeEnum.optional().nullable(),
    default_medium_recipe_id: mediumRecipeId.optional().nullable(),
    parent_procedure_id: fermentationProcedureId.optional().nullable(),
    is_locked: z.boolean().optional(),
    required_pre_cleaning_procedure_id: z.number().optional().nullable(),
    required_post_cleaning_procedure_id: z.number().optional().nullable(),
    owner_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    unit_preferences: z.unknown().optional().nullable(),
    archived_at: z.date().optional().nullable(),
    archived_by: operatorId.optional().nullable(),
    dashboard_id: z.number().optional().nullable(),
    pre_inoculation_pins: z.unknown().optional(),
});
//# sourceMappingURL=FermentationProcedure.js.map